// @ts-nocheck
(() => {
  if (window.__serumShowcaseModuleLoaded) return;
  window.__serumShowcaseModuleLoaded = true;

  const initializedAttribute = 'data-serum-showcase-initialized';

  const parseVariantIds = (rawValue) =>
    String(rawValue || '')
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);

  const waitForPBCart = async (maxTries = 60, delayMs = 100) => {
    for (let attempt = 0; attempt < maxTries; attempt += 1) {
      if (window.PBCart && typeof window.PBCart.addLine === 'function') {
        return window.PBCart;
      }
      await new Promise((resolve) => {
        setTimeout(resolve, delayMs);
      });
    }
    return null;
  };

  const getSerumGiftVariantId = (scope) => {
    if (window.SerumGiftPicker && typeof window.SerumGiftPicker.getSelectedVariantId === 'function') {
      const fromApi = window.SerumGiftPicker.getSelectedVariantId(scope);
      if (fromApi) return fromApi;
    }

    const input = scope.querySelector('[data-serum-gift-variant-input]');
    if (input && input.value) return String(input.value).trim();

    const picker = scope.querySelector('[data-serum-gift-picker][data-serum-gift-active="true"]');
    if (picker) {
      const fromAttr = picker.getAttribute('data-selected-gift-variant');
      if (fromAttr) return String(fromAttr).trim();
    }

    return null;
  };

  const initSection = (root) => {
    if (!root || root.getAttribute(initializedAttribute) === 'true') return;
    root.setAttribute(initializedAttribute, 'true');

    const track = root.querySelector('[data-serum-track]');
    const slides = Array.from(root.querySelectorAll('.serum-showcase__slide'));
    const dots = Array.from(root.querySelectorAll('[data-serum-dot]'));
    const modal = root.querySelector('[data-serum-gift-modal]');
    const closeOverlay = root.querySelector('[data-serum-modal-close]');
    const giftPicker = root.querySelector('[data-serum-gift-picker]');
    const giftInput = root.querySelector('[data-serum-gift-variant-input]');
    const giftOptionsContainer = root.querySelector('[data-serum-gift-options]');
    const giftFallback = root.querySelector('[data-serum-gift-fallback]');

    let currentIndex = 0;
    let selectedSerumVariantId = '';
    let touchStartX = 0;
    let touchCurrentX = 0;
    let isDragging = false;
    let modalSessionId = 0;
    let completedModalSessionId = 0;
    let modalInteractionReadyAt = 0;
    let cartSubmitLock = false;

    const slideCount = slides.length;
    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

    const updateDots = () => {
      for (const dot of dots) {
        dot.classList.toggle('is-active', dot.dataset.serumDot === String(currentIndex));
      }
    };

    const updateSlider = (animate = true) => {
      if (!track) return;

      if (!isMobile()) {
        track.style.transition = 'none';
        track.style.transform = 'none';
        return;
      }

      track.style.transition = animate ? 'transform 240ms ease' : 'none';

      const firstSlide = slides[0];
      if (!firstSlide) return;

      const trackStyles = window.getComputedStyle(track);
      const gapValue = trackStyles.columnGap || trackStyles.gap || '0';
      const gap = Number.parseFloat(gapValue) || 0;
      const slideWidth = firstSlide.getBoundingClientRect().width;
      const offset = currentIndex * (slideWidth + gap);

      track.style.transform = `translate3d(-${offset}px, 0, 0)`;
    };

    const goToSlide = (index, animate = true) => {
      if (slideCount <= 1) return;

      if (index < 0) index = slideCount - 1;
      if (index >= slideCount) index = 0;

      currentIndex = index;
      updateSlider(animate);
      updateDots();
    };

    const setGiftVariantId = (variantId) => {
      const value = variantId ? String(variantId) : '';

      if (giftInput) giftInput.value = value;

      if (giftPicker) {
        giftPicker.setAttribute('data-selected-gift-variant', value);
      }

      const giftCards = root.querySelectorAll('.serum-gift-option[data-gift-variant-id]');
      for (const giftCard of giftCards) {
        const selected = String(giftCard.dataset.giftVariantId || '') === value;
        giftCard.classList.toggle('is-selected', selected);
        giftCard.setAttribute('aria-pressed', selected ? 'true' : 'false');
      }
    };

    const giftConfig = [
      { variant: 'giftDayNormalVariantId', title: 'giftDayNormalTitle', image: 'giftDayNormalImage' },
      { variant: 'giftNightNormalVariantId', title: 'giftNightNormalTitle', image: 'giftNightNormalImage' },
      { variant: 'giftDayDryVariantId', title: 'giftDayDryTitle', image: 'giftDayDryImage' },
      { variant: 'giftNightDryVariantId', title: 'giftNightDryTitle', image: 'giftNightDryImage' }
    ];

    const buildGiftOptionsFromTrigger = (trigger) => {
      if (!giftOptionsContainer) return;

      const options = [];
      for (const item of giftConfig) {
        const variantId = trigger.dataset[item.variant] || '';
        if (!variantId) continue;
        options.push({
          variantId,
          title: trigger.dataset[item.title] || '',
          image: trigger.dataset[item.image] || ''
        });
      }

      giftOptionsContainer.innerHTML = '';

      if (!options.length) {
        if (giftFallback) giftFallback.hidden = false;
        setGiftVariantId('');
        return;
      }

      if (giftFallback) giftFallback.hidden = true;

      for (const [index, option] of options.entries()) {
        const giftOptionButton = document.createElement('button');
        giftOptionButton.type = 'button';
        giftOptionButton.className = `serum-gift-option${index === 0 ? ' is-selected' : ''}`;
        giftOptionButton.dataset.giftVariantId = option.variantId;
        giftOptionButton.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');

        if (option.image) {
          const image = document.createElement('img');
          image.className = 'serum-gift-option__img';
          image.src = option.image;
          image.alt = option.title || '';
          image.loading = 'lazy';
          giftOptionButton.appendChild(image);
        }

        if (option.title) {
          const label = document.createElement('span');
          label.className = 'serum-gift-option__label';
          label.textContent = option.title;
          giftOptionButton.appendChild(label);
        }

        giftOptionButton.addEventListener('click', () => {
          setGiftVariantId(option.variantId);
        });

        giftOptionsContainer.appendChild(giftOptionButton);
      }

      setGiftVariantId(options[0].variantId);
    };

    const isModalOpen = () => Boolean(modal && !modal.hidden);

    const canUseModalDismiss = () => Date.now() >= modalInteractionReadyAt;

    const hasCompletedCartAction = () => completedModalSessionId === modalSessionId;

    const setModalActionsDisabled = (disabled) => {
      if (!modal) return;
      modal.querySelectorAll(
        '[data-serum-confirm], [data-serum-no-gift], [data-serum-modal-close-btn], [data-open-gift-popup]'
      ).forEach((el) => {
        el.disabled = disabled;
      });
    };

    const openModal = () => {
      if (!modal) return;
      modalSessionId += 1;
      completedModalSessionId = 0;
      cartSubmitLock = false;
      modal.hidden = false;
      modalInteractionReadyAt = Date.now() + 350;
    };

    const closeModal = () => {
      if (!modal) return;
      modal.hidden = true;
      setModalActionsDisabled(false);
    };

    // Same contract as blocks/bulk-qty-buttons.liquid — one serum addLine, optional one gift addLine
    const addToCartWithOptionalSerumGift = async (variantId, includeGift) => {
      const pbCart = await waitForPBCart();
      if (!pbCart) {
        throw new Error('PBCart unavailable');
      }

      await pbCart.addLine(String(variantId), 1);

      if (includeGift) {
        const giftVariantId = getSerumGiftVariantId(root);
        if (giftVariantId) {
          await pbCart.addLine(String(giftVariantId), 1);
        }
      }

      if (typeof pbCart.current === 'function') {
        await pbCart.current();
      }
    };

    const finalizeCart = async (includeGift) => {
      if (!isModalOpen() || !selectedSerumVariantId) return;
      if (hasCompletedCartAction() || cartSubmitLock) {
        closeModal();
        return;
      }

      if (!includeGift && !canUseModalDismiss()) return;

      cartSubmitLock = true;
      completedModalSessionId = modalSessionId;
      setModalActionsDisabled(true);

      if (!includeGift) {
        setGiftVariantId('');
      }

      try {
        await addToCartWithOptionalSerumGift(selectedSerumVariantId, includeGift);
        closeModal();
      } catch (error) {
        console.warn('[Serum Showcase] add to cart failed', error);
        completedModalSessionId = 0;
        cartSubmitLock = false;
        setModalActionsDisabled(false);
      }
    };

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-open-gift-popup]');
      if (!trigger) return;
      if (trigger.disabled) return;

      event.preventDefault();

      const variantIds = [...new Set(parseVariantIds(trigger.getAttribute('data-serums')))];
      selectedSerumVariantId = variantIds[0] || '';
      if (!selectedSerumVariantId) return;

      buildGiftOptionsFromTrigger(trigger);
      openModal();
    });

    if (modal && modal.dataset.serumModalActionsBound !== 'true') {
      modal.dataset.serumModalActionsBound = 'true';

      modal.addEventListener('click', (event) => {
        if (!isModalOpen() || cartSubmitLock) return;

        if (event.target.closest('[data-serum-confirm]')) {
          event.preventDefault();
          event.stopPropagation();
          finalizeCart(true);
          return;
        }

        if (event.target.closest('[data-serum-no-gift]') || event.target.closest('[data-serum-modal-close-btn]')) {
          event.preventDefault();
          event.stopPropagation();
          finalizeCart(false);
          return;
        }

        if (event.target === closeOverlay && canUseModalDismiss()) {
          event.preventDefault();
          finalizeCart(false);
        }
      });
    }

    for (const dot of dots) {
      dot.addEventListener('click', () => {
        goToSlide(Number(dot.dataset.serumDot || '0'));
      });
    }

    if (track && slideCount > 1) {
      track.addEventListener(
        'touchstart',
        (event) => {
          if (!isMobile()) return;
          touchStartX = event.touches[0].clientX;
          touchCurrentX = touchStartX;
          isDragging = true;
          updateSlider(false);
        },
        { passive: true }
      );

      track.addEventListener(
        'touchmove',
        (event) => {
          if (!isMobile() || !isDragging) return;
          touchCurrentX = event.touches[0].clientX;
        },
        { passive: true }
      );

      track.addEventListener('touchend', () => {
        if (!isMobile() || !isDragging) return;
        isDragging = false;

        const deltaX = touchCurrentX - touchStartX;
        const threshold = 50;

        if (Math.abs(deltaX) < threshold) {
          updateSlider(true);
          return;
        }

        if (deltaX < 0) {
          goToSlide(currentIndex + 1);
          return;
        }

        goToSlide(currentIndex - 1);
      });
    }

    root.addEventListener('keydown', (event) => {
      if (!isModalOpen()) return;
      if (event.key !== 'Escape') return;
      if (!canUseModalDismiss()) return;
      finalizeCart(false);
    });

    let resizeFrame = null;
    window.addEventListener('resize', () => {
      if (resizeFrame) cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => {
        updateSlider(false);
      });
    });

    goToSlide(0, false);
  };

  const initAll = (scope) => {
    const root = scope && scope.querySelector ? scope : document;
    const sections = root.querySelectorAll('.serum-showcase');
    for (const section of sections) initSection(section);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target || document);
  });
})();
